import { composeWithDevTools } from 'redux-devtools-extension';
import { createStore, applyMiddleware } from 'redux';
import promiseMiddleware from 'redux-promise-middleware';
import logger from 'redux-logger';
import thunk from 'redux-thunk';

import rootReducer from '../redusers';

const middlewares = [thunk, promiseMiddleware];

if (process.env.NODE_ENV === 'development') {
    middlewares.push(logger);
}

export default function configureStore(initialState) {
    const store = createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(...middlewares)));

    const metaHot = import.meta.hot;

    if (metaHot) {
        metaHot.accept('../redusers', () => {
            const nextRootReducer = require('../redusers').default;
            store.replaceReducer(nextRootReducer);
        });
    }

    return store;
}
